module.exports = __webpack_public_path__ + "static/media/imi-logo.71300f22.png";